export default __webpack_public_path__ + "static/gearsound-3c03b3692281729d72aeaca4ce1335fe.mp3";